import { TokenElevationBackgroundChangeExample, TokenElevationChangeExample } from "../../../../src/components/interactive-elevations";
import pairingDo from "../../../../src/pages/foundations/elevation/_assets/pairing-do.png";
import pairingDont from "../../../../src/pages/foundations/elevation/_assets/pairing-dont.png";
import groupingDo from "../../../../src/pages/foundations/elevation/_assets/grouping-do.png";
import groupingDont from "../../../../src/pages/foundations/elevation/_assets/grouping-dont.png";
import * as React from 'react';
export default {
  TokenElevationBackgroundChangeExample,
  TokenElevationChangeExample,
  pairingDo,
  pairingDont,
  groupingDo,
  groupingDont,
  React
};